// extracted by css-extract-rspack-plugin
export default {"layer":"CustomDragLayer_layer__DHb1t","itemWrapper":"CustomDragLayer_itemWrapper__mOvIi"};